import { Spinner } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons'

interface DropdownLoaderProps {
  loading: boolean
}

export function DropdownLoader({ loading }: DropdownLoaderProps) {
  return !loading ? (
    <FontAwesomeIcon icon={faEllipsisV} size="1x" />
  ) : (
    <div className="d-flex justify-content-center">
      <Spinner size={'sm'} animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>
    </div>
  )
}
